export type ClientAccessibility = (typeof ClientAccessibility)[keyof typeof ClientAccessibility];

export const ClientAccessibility = {
    Dedicated: 'Dedicated',
    UmdaschGroup: 'UmdaschGroup',
    Public: 'Public',
} as const;
